import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import AnimatedText from "../components/AnimatedText";
import Seo from "../components/Seo";
import A from "../assets/images/disputeResolution/A.png";
import LCS from "../assets/images/disputeResolution/LCS.png";
import MN from "../assets/images/disputeResolution/MN.png";

const DisputeResolution = () => {
  const [showTop, setShowTop] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    const onScroll = () => {
      setShowTop(window.pageYOffset > 400);
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      const p = max > 0 ? doc.scrollTop / max : 0;
      setScrollProgress(p);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="info-page-wrapper font-inter">
      <Seo
        title="Dispute Resolution — Legal Platform"
        description="Professional litigation, arbitration, and mediation services to resolve legal conflicts efficiently."
        canonicalPath="/dispute-resolution"
        image="/favicon.png"
      />
      <Header />
      <Breadcrumbs />
      <main className="info-page-section py-5">
        <div
          className="info-page-main-card"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h1 className="home-hero-title text-center"><AnimatedText text="Dispute Resolution" /></h1>
          <div className="home-hero-text text-center">
            <AnimatedText text="Resolve legal conflicts with confidence through our professional dispute resolution services. Our verified lawyers specialize in litigation, arbitration, and mediation to help you reach fair and efficient settlements for commercial, civil, and personal disputes." />
          </div>
        </div>

        <div className="info-page-list">
          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="150"
          >
            <div className="info-page-block-content">
              <h3 className="info-page-block-title"><AnimatedText text="Litigation & Court Support" /></h3>
              <div className="info-page-block-text">
                <AnimatedText text="Get expert representation in civil and commercial courts. We handle case filing, evidence gathering, and courtroom advocacy to protect your legal rights and achieve the best possible outcomes." />
              </div>
            </div>
            <div className="info-page-block-image-wrapper">
              <img src={LCS} alt="Litigation & Court Support" className="info-page-block-image" />
            </div>
          </div>

          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="info-page-block-content">
              <h3 className="info-page-block-title"><AnimatedText text="Arbitration" /></h3>
              <div className="info-page-block-text">
                <AnimatedText text="Navigate private dispute resolution through arbitration. Our lawyers provide representation in domestic and international arbitration proceedings, ensuring a neutral and structured process for complex commercial matters." />
              </div>
            </div>
            <div className="info-page-block-image-wrapper">
              <img src={A} alt="Arbitration" className="info-page-block-image" />
            </div>
          </div>

          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="250"
          >
            <div className="info-page-block-content">
              <h3 className="info-page-block-title"><AnimatedText text="Mediation & Negotiation" /></h3>
              <div className="info-page-block-text">
                <AnimatedText text="Reach amicable settlements without the need for lengthy court battles. We facilitate professional mediation and strategic negotiation to resolve disputes quickly and cost-effectively." />
              </div>
            </div>
            <div className="info-page-block-image-wrapper">
              <img src={MN} alt="Mediation & Negotiation" className="info-page-block-image" />
            </div>
          </div>
        </div>
      </main>
      {showTop && (
        <button
          type="button"
          className="scroll-top-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          style={{ "--progress": `${Math.round(scrollProgress * 100)}%` }}
        >
          <span className="scroll-top-ring" />
          <i className="bi bi-arrow-up-short" />
        </button>
      )}
      <Footer />
    </div>
  );
};

export default DisputeResolution;
